"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addAssociations = addAssociations;
exports.removeAssociation = removeAssociation;

var _ActionTypes = require("crm_data/actions/ActionTypes");

var _BETAssociationsAPI = require("crm_ui/BET/engagementAssociations/api/BETAssociationsAPI");

var _Dispatch = require("crm_data/dispatch/Dispatch");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

function addAssociations(engagementId, BETPortalAssociations) {
  (0, _BETAssociationsAPI.createPortalEngagementAssociation)(engagementId, BETPortalAssociations.map(function (assoc) {
    return assoc.get('objectId');
  })).then(function () {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.BET_PORTAL_OBJECT_ASSOCIATIONS_ADD, {
      objectType: _ObjectTypes.ENGAGEMENT,
      engagementId: engagementId,
      BETPortalAssociations: BETPortalAssociations
    });
  }).done();
}

function removeAssociation(engagementId, BETPortalAssociation) {
  (0, _BETAssociationsAPI.removePortalEngagementAssociation)(engagementId, BETPortalAssociation.get('objectId')).then(function () {
    (0, _Dispatch.dispatchImmediate)(_ActionTypes.BET_PORTAL_OBJECT_ASSOCIATIONS_REMOVE, {
      objectType: _ObjectTypes.ENGAGEMENT,
      engagementId: engagementId,
      BETPortalAssociation: BETPortalAssociation
    });
  }).done();
}